<template>
    <div class="facebook-ads">
        <landing-page slot="no-integrations"
                      v-if="!hasIntegration(['Facebook ads'])"
                      image="/images/integrations/cta-messages/facebook.png"
                      :headline="$t('facebook.onboarding.headline')"
                      :description="$t('facebook.onboarding.description')"
        >
            <hr/>

            <integration name="Facebook ads"
                         service="facebook-ads"
                         :border="true"
                         logo="/images/onboarding/facebook.svg"
                         :headline="$t('facebook.onboarding.facebook.headline')"
                         :description="$t('facebook.onboarding.facebook.description')"
            />

            <hr/>
        </landing-page>

        <div class="container-fluid" v-else>
            <facebook-ads-overview/>
            <div class="row" v-for="status in statuses">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <campaigns :status="status"/>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .accountCurrency {
        display: inline-block;
    }
</style>

<script>
  import CheckForMissingIntegrations from '@/app/integrations/components/CheckForMissingIntegrations'
  import hasIntegration from '@/mixins/integrations/hasIntegration'
  import LandingPage from '@/app/onboarding/components/LandingPage'
  import Integration from '@/app/onboarding/components/integrations/Integration'

  import FacebookAdsOverview from '@/app/facebook/components/ads/FacebookAdsOverview'
  import Campaigns from '@/app/facebook/components/ads/Campaigns'

  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'FacebookAds',
    mixins: [hasIntegration],
    mounted () {
      this.checkForWebShopData()
    },
    computed: mapGetters('facebookAds', {
      statuses: 'getStatuses'
    }),
    methods: mapActions('facebookAds', ['checkForWebShopData']),
    components: {
      CheckForMissingIntegrations,
      FacebookAdsOverview,
      LandingPage,
      Campaigns,
      Integration
    }
  }
</script>
